import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-demo-eight',
  templateUrl: './home-demo-eight.component.html',
  styleUrls: ['./home-demo-eight.component.scss']
})
export class HomeDemoEightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
